export default "__VITE_ASSET__BgUdAXo0__"